"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinMenu = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _auth = require("@ori/auth");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../api");
var _navigation = require("../../context/navigation");
var _hooks = require("../../hooks");
var _JoinTileImage = require("./components/JoinTileImage/JoinTileImage");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const JoinMenu = () => {
  const {
    isUserVerified,
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    activeMenu,
    toggleActiveMenu
  } = (0, _navigation.useActiveMenu)();
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    data: items
  } = (0, _api.useGetNavigationType)({
    type: 'JoinTiles',
    enabled: isAnonymousUser && isUserVerified && !isMobile
  });
  const exitMenu = (0, _react.useCallback)(() => toggleActiveMenu(''), [toggleActiveMenu]);
  const iDontKnowYetLink = (0, _react.useMemo)(() => items.find(({
    linkType
  }) => linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.IDontKnowYet), [items]);
  const joinTiles = (0, _react.useMemo)(() => items.filter(({
    linkType
  }) => linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.MenuTiles), [items]);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMenuActive = activeMenu === ToggleMenuFlyout.MenuTypes.JoinMenu;
  if (joinTiles.length === 0 || isMobile) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.JoinMenuRoot, {
    "data-testid": getTestId(_constants.JOIN_MENU_ROOT),
    isVisible: isMenuActive,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.JoinTilesWrapper, {
      children: joinTiles.map(({
        url,
        imageUrl,
        title,
        description
      }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.JoinTileLink, {
        "data-testid": getTestId(_constants.JOIN_MENU_TILE_LINK),
        href: url,
        children: [imageUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_JoinTileImage.JoinTileImage, {
          image: imageUrl,
          name: title
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.JoinTileDescription, {
          "data-testid": getTestId(_constants.JOIN_MENU_TILE_DESCRIPTION),
          variant: "h4",
          children: description
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.JoinTileButton, {
          className: "joinTileTitle",
          variant: "contained",
          color: "primary",
          children: title
        })]
      }, url))
    }), iDontKnowYetLink?.url ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.JoinMenuIdkyLink, {
      href: iDontKnowYetLink.url,
      children: iDontKnowYetLink.title
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.JoinMenuBackdrop, {
      open: true,
      "data-testid": getTestId(_constants.JOIN_MENU_BACKDROP),
      onClick: exitMenu
    })]
  });
};
exports.JoinMenu = JoinMenu;